import { StorageService } from "./storage.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { Uris } from "./Uris";

@Injectable({
  providedIn: "root"
})
export class SubClientsService {
  constructor(
    public storageService: StorageService,
    private http: HttpClient,
    public router: Router
  ) {}

  getSubClients(query) {
    return this.http.get(`${Uris.SUBCLIENTS}${query}`, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getSubClient(id) {
    return this.http.get(`${Uris.SUBCLIENTS}${id}/`, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  postSubClient(value) {
    return this.http.post(`${Uris.SUBCLIENTS}`, value, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation("success", "Éxito", `Subcliente registrado correctamente`);
        return resp;
      })
    );
  }

  patchSubClient(id, value) {
    return this.http.patch(`${Uris.SUBCLIENTS}${id}/`, value, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation("success", "Éxito", `Subcliente editado correctamente`);
        return resp;
      })
    );
  }

  deleteSubClient(id) {
    return this.http.delete(`${Uris.SUBCLIENTS}${id}/`, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation("success", "Éxito", `Subcliente eliminada correctamente`);
        return resp;
      })
    );
  }
}
